import React, { ReactNode } from "react";
import ItemActions from "./ItemActions";

interface EditableListItemProps {
  children: ReactNode;
  onEdit?: () => void;
  onDelete?: () => void;
  canEdit?: boolean;
  className?: string;
  noPadding?: boolean;
}

export default function EditableListItem({
  children,
  onEdit,
  onDelete,
  canEdit = true,
  className = "",
  noPadding = false,
}: EditableListItemProps) {
  const baseClasses = noPadding
    ? "relative group"
    : "relative group border rounded-lg p-4";

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className={canEdit && onEdit && onDelete ? "pr-20" : ""}>
        {children}
      </div>
      {canEdit && onEdit && onDelete && (
        <ItemActions onEdit={onEdit} onDelete={onDelete} />
      )}
    </div>
  );
}
